import { FactoryType } from '@/types';
import {
  Card,
  CardContent,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { ChangeEvent } from 'react';
import Header from '../Header';

const networks = [
  { value: '137', label: 'polygon-main' },
  { value: '80002', label: 'polygon-test' },
] as const;

export default function FactorySettingForm({
  factory,
  setFactory,
  title,
  type,
}: {
  factory: FactoryType;
  setFactory: (value: any) => void;
  title: string;
  type: string;
}): JSX.Element {
  const handleChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    console.log(`handleChangeValue`);
    const { name, value } = e.target;
    if (!name) {
      return;
    }

    setFactory((prev: FactoryType) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeSelect = (e: SelectChangeEvent) => {
    const { name, value } = e.target;
    console.log(name);
    console.log(value);
    if (!name || !value) {
      return;
    }
    setFactory((prev: FactoryType) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <Card>
      <Header title={title} />
      <Divider />
      <CardContent>
        <Grid container spacing={3}>
          <Grid md={6} xs={12}>
            <FormControl fullWidth required>
              <InputLabel>제목</InputLabel>
              <OutlinedInput value={factory.title} label="title" name="title" onChange={handleChangeValue} />
            </FormControl>
          </Grid>

          <Grid md={6} xs={12}>
            <FormControl fullWidth required>
              <InputLabel>Network</InputLabel>
              <Select
                defaultValue="137"
                label="Network"
                name="network"
                variant="outlined"
                value={factory.network}
                onChange={handleChangeSelect}
              >
                {networks.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid md={6} xs={12}>
            <FormControl fullWidth required>
              <InputLabel>admin address</InputLabel>
              <OutlinedInput
                value={factory.adminAddress}
                label="admin address"
                name="adminAddress"
                onChange={handleChangeValue}
              />
            </FormControl>
          </Grid>

          <Grid md={6} xs={12}>
            <FormControl fullWidth required>
              <InputLabel>contract address</InputLabel>
              <OutlinedInput
                value={factory.contractAddr}
                label="contract address"
                name="contractAddr"
                onChange={handleChangeValue}
              />
            </FormControl>
          </Grid>

          <Grid xs={12}>
            <InputLabel>설명</InputLabel>
            <OutlinedInput
              value={factory.description}
              placeholder="풀 설명"
              multiline
              fullWidth
              rows={4}
              label="description"
              name="description"
              onChange={handleChangeValue}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
